import { Component, OnInit } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-google-contacts-list',
	templateUrl: './google-contacts-list.component.html',
	styleUrls: ['./google-contacts-list.component.css'],
})
export class GoogleContactsListComponent extends ListComponent {
	protected apiUrl = 'google/googleContacts';

	tableRows = [
		{ id: 'familyName', name: 'Nazwisko' },
		{ id: 'givenName', name: 'Imię' },
		{ id: 'numberWork', name: 'Telefon służbowy' },
		{ id: 'numberPrivate', name: 'Telefon prywatny' },
		{ id: 'mailWork', name: 'E-mail służbowy' },
		{ id: 'mailPrivate', name: 'E-mail prywatny' },
		{ id: 'occupation', name: 'Typ pracownika' },
		{ id: 'organizationJob', name: 'Stanowisko' },
	];
}
